import { computed, get } from '@ember/object';
import fmt from 'ember-string-fmt';

export default function readsAndFmtWithProperty(string, dependentKey) {
  return computed(dependentKey, function () {
    let key = fmt(string, get(this, dependentKey));
    return get(this, key);
  });
}
